module.exports = __webpack_public_path__ + "static/img/PH.bd6c2f44.svg";